import React from 'react';
import clsx, { ClassValue } from 'clsx';
import { useTranslation } from 'common/i18n/hooks';
import { InsightsLineChartReact } from 'common/report/insights/charts/insights-line-chart';
import { SegmentFilterController } from 'common/charts/contexts/segment-filter-controller';
import { useExperimentsStore } from 'apps/experiments/src/store';
import { formatMetricNumber } from 'common/util';
import { getLatestOverallSeriesValue } from 'apps/experiments/src/components/query-utils';
import { ReactErrorBoundary } from 'common/components/react-error-boundary';
import { PageTrackingEvent, trackExperimentPageAction } from 'apps/experiments/src/components/tracking';
import { ExperimentPageSummaryCard } from './card';
import styles from './_exposures-card.module.styl';
type ExperimentPageSummaryCardProps = {
  className?: ClassValue;
};
export const ExposuresSummaryCard: React.FC<ExperimentPageSummaryCardProps> = props => {
  const experimentState = useExperimentsStore(state => state.experimentState);
  const exposuresBookmarkParams = useExperimentsStore(state => state.exposuresBookmarkParams);
  const exposuresQueryResults = useExperimentsStore(state => state.exposuresQueryResults);
  const i18n = useTranslation();
  const segmentFilterController = React.useRef(new SegmentFilterController());
  const firedLoadEvent = React.useRef(false);
  if (!experimentState) {
    return null;
  }
  const exposures = experimentState.start_date && exposuresQueryResults ? formatMetricNumber(getLatestOverallSeriesValue(exposuresQueryResults)) : "--";
  const header = exposuresQueryResults ? i18n.t("experiments.main.summary.exposures", {
    exposures
  }) : i18n.t("experiments.main.summary.exposures-loading");
  React.useEffect(() => {
    if (exposuresQueryResults && !firedLoadEvent.current) {
      firedLoadEvent.current = true;
      trackExperimentPageAction({
        event: PageTrackingEvent.ExposuresLoaded,
        experiment: experimentState,
        props: {
          'experiment - exposures': getLatestOverallSeriesValue(exposuresQueryResults)
        }
      });
    }
  }, [exposuresQueryResults]);
  return <ExperimentPageSummaryCard className={clsx(props.className)} header={<div>{header}</div>} data-sentry-element="ExperimentPageSummaryCard" data-sentry-component="ExposuresSummaryCard" data-sentry-source-file="_exposures-card.tsx">
      {exposuresBookmarkParams && <ReactErrorBoundary>
          <InsightsLineChartReact loaded={!!exposuresQueryResults} emptyDataContainerClassName={styles.emptyData} paramsAndResults={{
        results: exposuresQueryResults!,
        params: exposuresBookmarkParams
      }} segmentFilterController={segmentFilterController.current} />
        </ReactErrorBoundary>}
    </ExperimentPageSummaryCard>;
};